export default __webpack_public_path__ + "static/biblestudy-e19a30d1c58aed7b41e8b8a840547e6d.jpg";